import { Plus } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * "Adicionar" das seções do catálogo.
 *
 * `topo` é o do cabeçalho — sólido, porque é a ação principal da seção e precisa ser achado sem
 * rolar a lista inteira. O tracejado é o de dentro de um grupo: mesma ação, escopo menor.
 */
export function BotaoAdicionar({
  onClick,
  children = "Adicionar",
  topo,
  title,
}: {
  onClick: () => void;
  children?: React.ReactNode;
  topo?: boolean;
  title?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md font-semibold transition-colors",
        topo
          ? "h-8 shrink-0 bg-brand-600 px-3 text-xs text-white shadow-sm hover:bg-brand-700"
          : "h-7 border border-dashed border-zinc-300 px-2.5 text-[11px] text-zinc-500 hover:border-brand-300 hover:text-brand-700 dark:border-border dark:text-muted-foreground",
      )}
    >
      <Plus className={topo ? "h-3.5 w-3.5" : "h-3 w-3"} />
      {children}
    </button>
  );
}
